<template>
    <WorkspaceFolderTree
        v-if="isWorkspaceSuggest"
        :class="{
            'workspace-suggestion-hidden': !showWorkspaceSuggest
        }"
        :service="workspaceFolderTreeService"
        @mousedown.native="(event) => preventDefaultEvent(event)"
    />
    <CustomFieldsModal
        v-else-if="isCustomField"
        :loading="customFieldValueLodading"
        :title="customFieldSuggestTitle"
        :type="customFieldType"
        :list="customFieldValue"
        :stem="customFieldStem"
        @onSelect="onSelectCustomField"
        @mousedown.native="(event) => preventDefaultEvent(event)"
    />
    <SuggestionBoard
        v-else
        :default-status="isDefaultStatus"
        :suggestion="suggestionList"
        :selected-index="dropData.selectIndex"
        :analytics-domain="analyticsDomain"
        :stem-keyword="stem"
        @update-selected-index="updateSelectedIndex"
        @select="({ index }) => selectOption(SELECT_OPTIONS_SELECTED, index)"
        @select-query="handleSelectQuery"
    />
</template>

<script>
/* eslint-disable no-plusplus */
/* eslint-disable vue/require-default-prop */
/* eslint-disable vue/require-prop-types */
/* eslint-disable class-methods-use-this */
import {
    get, forEach, cloneDeep,
} from 'lodash';
import SuggestionBoard from '@patsnap-biz/suggestion-board';
import WorkspaceFolderTree from '@patsnap-biz/workspace-folder-tree';
import { formatKeyWord } from '../utils';
import {
    SELECT_OPTIONS_PRE_SELECTED,
    SELECT_OPTIONS_SELECTED,
    DEFAULT_SORT,
    SECTION_TYPE_FIELD,
    SECTION_TYPE_SAMPLE,
    SECTION_TYPE_QUERY,
} from '../constants';

import workspaceFolderMixin from '../mixin/workspaceFolderMixin';
import customFieldMixin from '../mixin/customFieldMixin';

const MODAL_WIDTH = 380;

const WORKSPACE_FOLDER_WIDTH = 660;

export default {
    name: 'SuggestionModal',
    components: {
        SuggestionBoard,
        WorkspaceFolderTree,
    },
    mixins: [
        workspaceFolderMixin,
        customFieldMixin,
    ],
    props: {
        suggestion: {
            default() {
                return [];
            },
        },
        dropData: {
            default() {
                return {
                    currentChar: '',
                    selectIndex: -1,
                };
            },
        },
        position: {
            type: Object,
        },
        analyticsDomain: {
            type: String,
            default: '',
        },

        specialSuggestRequest: {
            type: Object,
            default: () => ({}),
        },
        stem: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            modalPos: cloneDeep(this.position),
            currentSection: '',
        };
    },
    computed: {
        suggestionList() {
            if (this.isWorkspaceSuggest) return [];
            let index = 0;
            const suggestionList = cloneDeep(this.suggestion)
                .sort((a, b) => DEFAULT_SORT.indexOf(a.section) - DEFAULT_SORT.indexOf(b.section));
            forEach(suggestionList, (item) => {
                forEach(item.content, (subItem) => {
                    // eslint-disable-next-line no-param-reassign
                    subItem.index = index;
                    index++;
                });
            });
            return suggestionList;
        },
        selectIndex() {
            return this.dropData.selectIndex;
        },
        dropList() {
            let dropList = [];
            forEach(this.suggestionList, (item) => {
                dropList = dropList.concat(item.content);
            });
            return dropList;
        },
        lang() {
            return get(this, '$i18n.locale', 'en');
        },
        isDefaultStatus() {
            const { suggestionList } = this;
            for (let i = 0, size = suggestionList.length; i < size; i++) {
                const { section, isDefault } = suggestionList[i];
                if (section === SECTION_TYPE_FIELD && isDefault) {
                    return true;
                }
            }
            return false;
        },
    },
    watch: {
        selectIndex(newVal) {
            let index = newVal;
            if (index >= this.dropList.length) {
                index = this.dropList.length - 1;
            }
            if (newVal === undefined) return;
            this.previewOption(index);
        },
        suggestion() {
            this.previewOption();
        },
        position() {
            this.updateModalPos();
        },
    },

    created() {
        this.formatKeyWord = formatKeyWord;
        this.SELECT_OPTIONS_SELECTED = SELECT_OPTIONS_SELECTED;
    },
    mounted() {
        this.$nextTick(() => {
            this.updateModalPos();
            this.previewOption();
        });
    },
    methods: {
        previewOption(index = -1) {
            this.selectOption(SELECT_OPTIONS_PRE_SELECTED, index);
        },
        selectOption(type, index) {
            this.updateCurrentSection(index);
            const data = cloneDeep(this.dropList[index]);
            if (this.currentSection === SECTION_TYPE_SAMPLE) return;
            const option = {
                type,
                section: this.currentSection,
                selectIndex: index,
                data,
            };
            if (type === SELECT_OPTIONS_PRE_SELECTED) {
                this.$emit('preview-option', option);
            } else {
                this.$emit('select-option', option);
            }
        },
        updateModalPos() {
            //   if (this.isDefaultStatus) return;
            const modalWidth = this.isWorkspaceSuggest ? WORKSPACE_FOLDER_WIDTH : MODAL_WIDTH;
            const editorWidth = this.$el.parentElement.offsetWidth;
            let left = get(this.position, 'left');
            const offsetRight = get(this.position, 'offset.right', 0);
            left = left < 0 ? 0 : left;
            const maxLeft = editorWidth + offsetRight - modalWidth;
            left = Math.min(left, maxLeft);
            if (modalWidth >= editorWidth) {
                left = 0;
            }
            if (left && left > 0) {
                this.$el.style.left = `${left}px`;
            } else {
                this.$el.style.left = '0px';
            }
        },
        updateCurrentSection(index) {
            if (this.isCustomField || this.isWorkspaceSuggest) return;
            let start = 0;
            let end = 0;
            forEach(this.suggestionList, ({ section, content }) => {
                const { length } = content;
                end = length + start;
                if (index >= start && index < end) {
                    this.currentSection = section;
                }
                start += length;
            });
        },
        updateSelectedIndex(index) {
            this.$emit('update-selected-index', index);
        },
        handleSelectQuery(query) {
            const option = {
                data: { value: query },
                section: SECTION_TYPE_QUERY,
            };
            this.$emit('select-option', option);
        },
    },
};
</script>
